import { ICLFaultType } from '../enums/icl';

export const ICLFaultTypeText: Record<ICLFaultType, string> = {
  [ICLFaultType.Mechanical]: '1MEC  Mechanical Failure',
  [ICLFaultType.ExternalInfluence]: '2EXT  External Influence',
  [ICLFaultType.MaterialFailure]: '3MAT  Material Failure',
  [ICLFaultType.ElectricalFailure]: '4ELC  Electrical Failure',
  [ICLFaultType.InstrumentationFailure]: '5INS  Instrumentation Failure',
  [ICLFaultType.Miscellaneous]: '6MSC  Miscellaneous',
};

export const ICLFaultList: Record<ICLFaultType, string[]> = {
  [ICLFaultType.Mechanical]: [
    '1010 Deviation / Drift / Misalignment',
    '1020 Construction / Assembly',
    '1030 Deformation',
    '1040 Jamming / Slowing / Stoppage',
    '1050 Hydraulic',
    '1060 Leakage',
    '1070 Loose / Unsecured',
    '1080 Pneumatic',
    '1090 Pressure',
    '1100 Safety',
    '1110 Noise',
    '1120 Sticking / Adhesion',
    '1130 Temperature',
    '1140 Vibration',
    '1150 Working Conditions',
  ],

  [ICLFaultType.ExternalInfluence]: [
    '1010  Blockage / Clogging',
    '1020  Contamination',
    '1030  Material Crystallization',
  ],

  [ICLFaultType.MaterialFailure]: [
    '1010 Wear',
    '1020 Fracture',
    '1030 Explosion / Rupture / Burst',
    '1040 Tear / Tearing',
    '1050 Cavitation',
    '1060 Corrosion',
    '1070 Crack',
    '1080 Overheating',
  ],

  [ICLFaultType.ElectricalFailure]: [
    '1010 Grounding / Insulation',
    '1020 Improper Power Supply',
    '1030 No Power',
    '1040 Overload',
    '1050 Short Circuit',
    '1060 Excessive No-Load Current',
    '1070 Lighting Failure',
  ],

  [ICLFaultType.InstrumentationFailure]: [
    '1010 Calibration',
    '1030 Control',
    '1040 Incorrect Signal',
    '1050 No Signal',
    '1060 Software',
  ],

  [ICLFaultType.Miscellaneous]: [
    '1010 Not Operating',
    '1020 Malfunction',
    '1030 No Fault Found',
    '1035 Project',
  ],
};
